import { Slider } from '@material-ui/core';
import {
  StyledPercentageSlider,
  StyledSliderHandler,
  StyledTrack,
  StyledTrackPart,
  StyledTrackPartTitle,
  StyledTrackPartValue
} from './PercentageSlider.style';
import { useAutoAnimate } from '@formkit/auto-animate/react';

//config structure: [{value: Number, color: String, name: String}]

const PercentageSlider = ({ config, step = 1, onChange }) => {
  const [animationParent] = useAutoAnimate({ duration: 1000 });

  const onHandlerChange = (e, newValues) => {
    const percentValues = newValues.map((val, idx) => {
      if (idx === 0) return val;
      return newValues[idx] - newValues[idx - 1];
    });
    const updatedConfig = config.map((cat, idx) => ({
      ...cat,
      value: percentValues[idx]
    }));
    onChange(updatedConfig);
  };

  const percentValues = config.map(cat => cat.value);

  //convert percentageValues to absolute values. example: [25, 25, 25, 25] => [25, 50, 75, 100];
  const handlerValues = percentValues.map((s => a => (s += a))(0)); //prettier-ignore

  return (
    <StyledPercentageSlider>
      <StyledTrack ref={animationParent}>
        {config.map(cat => (
          <StyledTrackPart key={cat.name} value={cat.value} color={cat.color}>
            <StyledTrackPartValue>{cat.value}%</StyledTrackPartValue>
            <StyledTrackPartTitle>{cat.name}</StyledTrackPartTitle>
          </StyledTrackPart>
        ))}
      </StyledTrack>
      <StyledSliderHandler>
        <Slider value={handlerValues} onChange={onHandlerChange} step={step} />
      </StyledSliderHandler>
    </StyledPercentageSlider>
  );
};

export default PercentageSlider;
